var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLevel4 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21.766,
  height: 17.49
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "level4_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h21.766v17.49H0z",
  "data-name": "Rectangle 18367"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#level4_svg__a)",
  "data-name": "Group 644061"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M20.766 2H10.35a1 1 0 1 1 0-2h10.416a1 1 0 0 1 0 2",
  "data-name": "Path 647964"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#772432",
  d: "M20.766 5.872H10.35a1 1 0 0 1 0-2h10.416a1 1 0 0 1 0 2",
  "data-name": "Path 647965"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#772432",
  d: "M20.766 9.745H10.35a1 1 0 1 1 0-2h10.416a1 1 0 0 1 0 2",
  "data-name": "Path 647966"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#772432",
  d: "M20.766 13.618H10.35a1 1 0 1 1 0-2h10.416a1 1 0 0 1 0 2",
  "data-name": "Path 647967"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#772432",
  d: "M20.766 17.49H10.35a1 1 0 1 1 0-2h10.416a1 1 0 0 1 0 2",
  "data-name": "Path 647968"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#004165",
  d: "M3.943 14.57V11.6H0v-1.313L3.8 2.92h1.846v7.134h1.2V11.6h-1.2v2.97Zm0-4.516v-2.8c0-.7.054-1.4.108-2.079H4a40 40 0 0 1-.9 1.989l-1.416 2.85v.036Z",
  "data-name": "Path 647969"
}))));
export { SvgLevel4 as ReactComponent };
export default __webpack_public_path__ + "27c035c54d20c6df81279fc68f696eb3.svg";